export default {
  beforeMount(el, binding) {
    const handler = (e) => {
      if (!el.contains(e.target)) {
        binding.value(e);
      }
    };

    el.__closableHandler__ = handler;

    document.addEventListener("click", handler);
    document.addEventListener("touchstart", handler);
  },

  unmounted(el) {
    const handler = el.__closableHandler__;
    if (handler) {
      document.removeEventListener("click", handler);
      document.removeEventListener("touchstart", handler);
      delete el.__closableHandler__;
    }
  },
};